import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  showText?: boolean;
}

export function Logo({
  className,
  iconClassName = "h-8 w-8",
  textClassName = "text-xl font-bold font-heading",
  showText = true,
}: LogoProps) {
  return (
    <div className={cn("flex items-center space-x-2.5 select-none", className)}>
      <div className={cn("relative flex items-center justify-center shrink-0", iconClassName)}>
        <svg className="w-full h-full" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="q-logo-gradient-1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#6366f1" /> {/* Indigo-500 */}
              <stop offset="100%" stopColor="#2563eb" /> {/* Blue-600 */}
            </linearGradient>
            <linearGradient id="q-logo-gradient-2" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3b82f6" /> {/* Blue-500 */}
              <stop offset="100%" stopColor="#06b6d4" /> {/* Cyan-500 */}
            </linearGradient>
          </defs>
          
          {/* Outer circle of the Q (leaving a gap for the tail) */}
          <path
            d="M16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C19.1026 28 21.9168 26.8227 24.0326 24.8872"
            stroke="url(#q-logo-gradient-1)"
            strokeWidth="3.5"
            strokeLinecap="round"
          />
          
          {/* Inner Document/Invoice Card sheet */}
          <rect
            x="11"
            y="10"
            width="10"
            height="12"
            rx="1.5"
            stroke="url(#q-logo-gradient-2)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          {/* Document lines */}
          <line
            x1="14"
            y1="13.5"
            x2="18"
            y2="13.5"
            stroke="url(#q-logo-gradient-2)"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <line
            x1="14"
            y1="17.5"
            x2="18"
            y2="17.5"
            stroke="url(#q-logo-gradient-2)"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          
          {/* Diagonal checkmark tail of the Q */}
          <path
            d="M20 20L24 24L30 18"
            stroke="url(#q-logo-gradient-1)"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {showText && (
        <span className={cn("tracking-tight font-extrabold text-slate-900 dark:text-white", textClassName)}>
          Quick<span className="bg-gradient-to-r from-indigo-600 to-blue-500 bg-clip-text text-transparent">Free</span>Invoice
        </span>
      )}
    </div>
  );
}
